import { Children, isValidElement, Fragment } from 'react';
import { isFunction } from './assertion.esm.js';

/* eslint-disable no-param-reassign */
function setRef(ref, value) {
  if (ref === void 0) {
    ref = null;
  }

  if (!ref) {
    return;
  }

  if (typeof ref === 'function') {
    ref(value);
  } else {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
}
/**
 * Assigns a value to a ref function or object
 *
 * @param ref the ref to assign to
 * @param value the value
 */

function assignRef(ref, value) {
  if (ref == null) return;

  if (isFunction(ref)) {
    ref(value);
    return;
  }

  try {
    // @ts-ignore
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
  }
}
/**
 * Combine multiple React refs into a single ref function.
 * This is used mostly when you need to allow consumers forward refs to
 * internal components
 *
 * @param refs refs to assign to value to
 */

function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
}
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */

function cleanChildren(children) {
  return Children.toArray(children).filter(function (child) {
    return isValidElement(child);
  });
}
/**
 * Get a list of children, including those within Fragments
 * @param children
 */

function flattenChildren(children) {
  return cleanChildren(children).map(function (child) {
    return child.type === Fragment ? child.props.children : child;
  }).flat();
}

export { assignRef, cleanChildren, flattenChildren, mergeRefs, setRef };
//# sourceMappingURL=react-helpers.esm.js.map
